/**
 * @desc 根据银行卡号获取银行信息
 */
import { BankCard } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBankCardParameter = {
  cardno?: string
}

const method = 'GET'
const url = '/nexus/bank/card'

export const queryBankCardApi = (
  params?: QueryBankCardParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BankCard>({
    method,
    url,
    params,
    ...config
  })
}

queryBankCardApi.method = method
queryBankCardApi.url = url
